module.exports = __webpack_public_path__ + "resources/img/img_tibero3_m_en.a2db86a5915688aec7c19e05800d4bc7.png";